"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _MetaHeader = _interopRequireDefault(require("./MetaHeader"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = _MetaHeader["default"];
exports["default"] = _default;